"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * fixez la taille avec class : small, xs
 */
ngModule.directive('tlCircularLoader', function () {
  return {
    restrict: 'E',
    scope: true,
    replace: true,
    template: require("./tl-circular-loader.html"),
    link: function link($scope, $el, $attrs) {}
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/loaders/tl-circular-loader.js
// module id = 2979
// module chunks = 13